import { Link } from 'react-router-dom';

import {AuthCardLayout} from "@layouts/AuthCardLayout";
import './XeroConnectedPage.css';

export function ConnectedIntegration() {
  // Get current date and time for the connection timestamp
  const now = new Date();
  const formattedDate = now.toLocaleDateString('en-AU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });
  const formattedTime = now.toLocaleTimeString('en-AU', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  return (
    <AuthCardLayout>
      <div className="xero-connected-container">
        <div className="success-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
          </svg>
        </div>
        
        <h1 className="connected-title">Xero Connected Successfully!</h1>
        <p className="connected-subtitle">
          Your Xero account has been securely connected to Pecunio AI
        </p>
        
        <div className="connection-flow">
          <div className="pecunio-icon">
            <span>P</span>
            <span className="connection-badge">2</span>
          </div>
          <div className="connection-line">
            <div className="connection-dot"></div>
          </div>
          <div className="xero-icon">
            <img src="/xero-logo.svg" alt="Xero" />
          </div>
        </div>
        
        <div className="connection-details-card">
          <h3 className="card-title">🔒 Connection Details</h3>
          
          <div className="detail-row">
            <span className="detail-label">Organization</span>
            <span className="detail-value">Acme Corp Pty Ltd</span>
          </div>
          
          <div className="detail-row">
            <span className="detail-label">Connection Status</span>
            <span className="detail-value status-active">
              <span className="status-dot"></span> Active
            </span>
          </div>
          
          <div className="detail-row">
            <span className="detail-label">Permissions</span>
            <span className="detail-value">Read Financial Data</span>
          </div>
        </div>
        
        <div className="whats-next-card">
          <h3 className="card-title">⚡ What's next?</h3>
          
          <ul className="next-steps-list">
            <li>
              <span className="step-icon">⚡</span>
              <span className="step-text">We'll automatically sync your financial data</span>
            </li>
            <li>
              <span className="step-icon">⚡</span>
              <span className="step-text">AI insights will be generated from your transactions</span>
            </li>
            <li>
              <span className="step-icon">⚡</span>
              <span className="step-text">You'll receive intelligent financial recommendations</span>
            </li>
            <li>
              <span className="step-icon">⚡</span>
              <span className="step-text">Real-time cash flow monitoring is now active</span>
            </li>
          </ul>
        </div>
        
        <Link to="/dashboard" className="dashboard-button">
          Continue to Dashboard
        </Link>
        
        <div className="connection-timestamp">
          Connected on {formattedDate} at {formattedTime}
        </div>
      </div>
    </AuthCardLayout>
  );
}

export default ConnectedIntegration;
